var plugin_rtlignore_default = {
  "alignLeft": "-WJPH",
  "textWrapNowrap": "FMF3Z",
  "alignRight": "tlxwg",
  "alignCenter": "_3U5f5",
  "sizeFullWidth": "gANmv",
  "renderedInTable": "chINu",
  "sizeOriginal": "t-lbH",
  "sizeContent": "_29oD-",
  "sizeSmall": "hmbog",
  "sizeSmallCenter": "RIfJx",
  "flex": "VLZBF",
  "atomic": "_0KbPl",
  "embed": "M-qvA",
  "horizontalScrollbar": "HcHq0",
  "pluginContainerMobile": "lsfE6"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
